import LogoBinaryOrange from '../assets/logo-binary-orange.png';
import BackgroundCows from '../assets/bg-cow.jpg';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../lib/auth';
import { motion } from 'motion/react';
import { toast } from 'sonner';

const LoginPage = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    const isInIframe = window.self !== window.top;

    if (isInIframe) {
      instance.loginPopup(loginRequest).catch((e) => {
        console.error('Popup login failed', e);
        if (e.message?.includes('AADSTS9002326')) {
          toast.error('AZURE CONFIG ERROR', {
            description:
              "Your Azure App must be set to 'Single-page application' (SPA) platform type.",
            duration: 15000,
          });
        } else if (e.name === 'BrowserAuthError' && e.errorCode === 'user_cancelled') {
          toast.error('LOGIN CANCELLED');
        } else {
          toast.error('POPUP BLOCKED OR FAILED');
        }
      });
    } else {
      instance.loginRedirect(loginRequest).catch((e) => {
        console.error('Redirect login failed', e);
        toast.error('LOGIN FAILED');
      });
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-4"
      style={{
        backgroundImage: `url(${BackgroundCows})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center border border-slate-100"
      >
        <div className="flex items-center justify-center mx-auto mb-6">
          <img src={LogoBinaryOrange} alt="The majestic Binary logo" width="200" />
        </div>
        <h1 className="text-3xl font-bold text-slate-900 mb-2">Release Notes & Documentation</h1>
        <p className="text-slate-500 mb-8 text-lg">Making some sense of it all</p>

        <div className="space-y-3">
          {/* The one place a background and its label move in opposite
              directions, so it needs the `dark:` variant rather than the
              palette. In dark, bg-slate-900 already resolves to the lightest
              warm step, giving the bone-on-dark inverse button binary.ax uses
              on its dark sections — the label just has to stop being white. */}
          <button
            onClick={handleLogin}
            className="w-full bg-slate-900 hover:bg-slate-800 text-white dark:text-black font-bold py-4 px-6 rounded-xl flex items-center justify-center gap-3 transition-all transform active:scale-[0.98] disabled:opacity-70"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
              className="w-5 h-5"
              alt="Microsoft"
            />
            Sign in with Microsoft
          </button>
        </div>

        <div className="mt-8 flex items-center justify-center gap-4 text-xs text-slate-400 uppercase tracking-widest font-semibold">
          <span className="h-px w-8 bg-slate-200" />
          <p>&copy; {new Date().getFullYear()} Binary IS Limited</p>
          <span className="h-px w-8 bg-slate-200" />
        </div>
      </motion.div>
    </div>
  );
};

export default LoginPage;